// extracted by mini-css-extract-plugin
export default {"gradientHeader":"GradientHeader_gradientHeader__OiRu+","banner":"GradientHeader_banner__4D7cN","gradient":"GradientHeader_gradient__UP24b"};